import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { createApartment } from '../../services/apartmentService';
import { getPlaces } from '../../services/placeService';
import SuccessMessageModal from '../Reusable/SuccessMessageModal';
import WarningMessageModal from '../Reusable/WarningMessageModal';

const CreateApartmentModal = ({ isOpen, onClose, onApartmentCreated }) => {
  const [formData, setFormData] = useState({
    place_id: '',
    matricula: '',
  });
  const [places, setPlaces] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const selectedPlaceId = sessionStorage.getItem("selectedPlaceId");
  const isAdmin = sessionStorage.getItem("isAdmin") === 'true';

  useEffect(() => {
    if (isOpen) {
      if (selectedPlaceId) {
        setFormData((prev) => ({ ...prev, place_id: selectedPlaceId }));
      }
      if (isAdmin && !selectedPlaceId) {
        const fetchPlaces = async () => {
          try {
            const response = await getPlaces();
            setPlaces(response.data);
          } catch (error) {
            setModalMessage('Error al cargar las sedes.');
            setIsWarningOpen(true);
          }
        };
        fetchPlaces();
      }
    }
  }, [isOpen, selectedPlaceId, isAdmin]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      await createApartment(formData);
      setModalMessage('Apartamento creado correctamente.');
      setIsSuccessOpen(true);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error al crear el apartamento.';
      setModalMessage(errorMessage);
      setIsWarningOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setIsSuccessOpen(false);
    onApartmentCreated();
    onClose();
  };

  return (
    <>
      <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Crear Nuevo Apartamento</DialogTitle>
      <DialogContent>
        {isAdmin && !selectedPlaceId && (
          <FormControl fullWidth margin="dense">
            <InputLabel>Sede</InputLabel>
            <Select name="place_id" value={formData.place_id} onChange={handleChange}>
              {places.map((place) => (
                <MenuItem key={place.id} value={place.id}>
                  {place.name_place}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <TextField
          autoFocus
          margin="dense"
          name="matricula"
          label="Matrícula"
          type="text"
          fullWidth
          variant="standard"
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? <CircularProgress size={24} /> : 'Crear'}
        </Button>
      </DialogActions>
    </Dialog>
    <SuccessMessageModal isOpen={isSuccessOpen} message={modalMessage} onClose={handleSuccessClose} />
    <WarningMessageModal isOpen={isWarningOpen} message={modalMessage} onClose={() => setIsWarningOpen(false)} />
    </>
  );
};

export default CreateApartmentModal;
